<smrts-page tabTitle="Configurar Relatório Caixa">

  <div header class="header-container">

    <h1 #overflow="smrtsOverflowDetector" smrtsOverflowDetector class="primary-color page-title"
    matTooltip="Configurar Relatório Caixa" [matTooltipDisabled]="!overflow.truncado">Configurar Relatório Caixa</h1>

    <a routerLink="/relatorio-financeiro" mat-icon-button matTooltip="Voltar" class="accent-color">
      <mat-icon>arrow_back</mat-icon>
    </a>

    <mat-divider [vertical]="true" class="vertical-mat-divider"></mat-divider>

    <button mat-stroked-button matTooltip="Editar" (click)="popoverRelatorio.toggle($event)">
      <i class="pi pi-pencil button-menu-icon"></i>
      <span class="button-menu-label">Editar</span>
    </button>

    <p-popover #popoverRelatorio appendTo="body">
      <div class="popover-relatorio-content">
        <app-generic-autocomplete
          [items]="relatorios"
          displayField="nome"
          label="Buscar relatório existente"
          inputId="relatorioSelecionado"
          (selectionChange)="onRelatorioSelecionado($event); popoverRelatorio.hide()">
        </app-generic-autocomplete>

        <div class="somente-xsmall">
          <mat-divider></mat-divider>

          <button mat-stroked-button class="btn-novo-popover" (click)="novoClick(); popoverRelatorio.hide()">
            <i class="pi pi-plus button-menu-icon"></i>
            Novo relatório
          </button>
        </div>
      </div>
    </p-popover>

    <button mat-stroked-button class="btn-novo-header" matTooltip="Novo" (click)="novoClick()">
      <i class="pi pi-plus button-menu-icon"></i>
      <span class="button-menu-label">Novo</span>
    </button>

    <button mat-flat-button class="white-text-button btn-salvar" (click)="salvar()" [disabled]="salvando">
      {{ salvando ? 'Salvando...' : 'Salvar' }}
    </button>

  </div>

  <div class="content">

    <mat-card class="main-card">

      <!-- Nome do relatório + busca geral -->
      <div class="topo-linha1">
        <p-floatlabel variant="on" class="nome-relatorio-campo">
          <input pInputText type="text" [(ngModel)]="relatorio.nome" class="input-full-width" />
          <label>Nome do relatório</label>
        </p-floatlabel>

        <!-- Busca geral: categorias, contas e tipos -->
        <div class="busca-geral">
          <p-floatlabel variant="on">
            <p-iconField iconPosition="left">
              <p-inputIcon styleClass="pi pi-search"></p-inputIcon>
              <input pInputText id="buscaGeral" [(ngModel)]="buscaGeral" />
            </p-iconField>
            <label for="buscaGeral">Buscar</label>
          </p-floatlabel>
        </div>
      </div>

      <!-- Campos da categoria ativa -->
      @if (categoriaAtiva) {
        <div class="topo-linha2">
          <p-floatlabel variant="on">
            <input pInputText type="text" [(ngModel)]="categoriaAtiva.nome" class="input-full-width" />
            <label>Nome da categoria</label>
          </p-floatlabel>
          <p-floatlabel variant="on">
            <input pInputText type="text" [(ngModel)]="categoriaAtiva.identificadorCategoria" class="input-full-width" />
            <label>Identificador</label>
          </p-floatlabel>
          <p-floatlabel variant="on">
            <input pInputText type="text" [(ngModel)]="categoriaAtiva.observacaoCategoria" class="input-full-width" />
            <label>Observação da categoria</label>
          </p-floatlabel>
        </div>
      }

      <div class="card-body">

        <p-splitter [style]="{ height: '100%' }" [panelSizes]="[20, 80]" [minSizes]="[10, 40]">

          <ng-template #panel>
            <!-- Lista de categorias (esquerda) -->
            <div class="categorias-painel">

              <div class="categorias-lista">
                @for (categoria of categoriasFiltradas; track categoria) {
                  <div
                    class="categoria-item"
                    [class.categoria-ativa]="categoria === categoriaAtiva"
                    (click)="selecionarCategoria(categoria)">
                    <span class="categoria-nome">{{ categoria.nome || '(sem nome)' }}</span>
                    <button mat-icon-button class="btn-remover-categoria" (click)="removerCategoriaClick(categoria); $event.stopPropagation()">
                      <i class="pi pi-times"></i>
                    </button>
                  </div>
                }
              </div>

              <button mat-stroked-button class="btn-add-categoria" (click)="adicionarCategoria()">
                <i class="pi pi-plus"></i>
                Categoria
              </button>

            </div>
          </ng-template>

          <ng-template #panel>
            <!-- Formulário da categoria (direita) -->
            <div class="categoria-form">

              <!-- Tabela de tipos por conta -->
              <p-table
                [value]="contasFiltradas"
                dataKey="nomeConta"
                [expandedRowKeys]="expandedRows"
                [paginator]="true"
                [rows]="10"
                [rowsPerPageOptions]="[10, 25, 50]"
                class="tipos-table">

                <ng-template pTemplate="colgroup">
                  <colgroup>
                  <col style="width: 40px">
                  <col style="width: 40px">
                  <col>
                  </colgroup>
                </ng-template>

                <ng-template pTemplate="body" let-conta let-expanded="expanded">
                  <tr class="row-conta" [class.row-disabled]="isContaDisabled(conta)" (click)="toggleConta(conta)">
                    <td (click)="$event.stopPropagation()">
                      <p-button
                        type="button"
                        pRipple
                        [pRowToggler]="conta"
                        [text]="true"
                        [rounded]="true"
                        [plain]="true"
                        [icon]="expanded ? 'pi pi-chevron-down' : 'pi pi-chevron-right'">
                      </p-button>
                    </td>
                    <td (click)="$event.stopPropagation()">
                      <p-checkbox
                        [binary]="true"
                        [ngModel]="isContaSelecionada(conta)"
                        [indeterminate]="isContaIndeterminate(conta)"
                        [disabled]="isContaDisabled(conta)"
                        (ngModelChange)="toggleConta(conta)">
                      </p-checkbox>
                    </td>
                    <td class="nome-conta">{{ conta.nomeConta }}</td>
                  </tr>
                </ng-template>

                <ng-template pTemplate="expandedrow" let-conta>
                  @for (tipo of conta.tipos; track tipo) {
                    <tr class="row-tipo"
                      [class.row-disabled]="isTipoDisabled(tipo.id)"
                      (click)="toggleTipo(tipo)">
                      <td></td>
                      <td (click)="$event.stopPropagation()">
                        <p-checkbox
                          [binary]="true"
                          [ngModel]="isTipoSelecionado(tipo.id)"
                          [disabled]="isTipoDisabled(tipo.id)"
                          (ngModelChange)="toggleTipo(tipo)">
                        </p-checkbox>
                      </td>
                      <td class="nome-tipo">
                        {{ tipo.nome }}
                        @if (categoriaDoTipo(tipo.id); as categoriaDoTipoAtual) {
                          <span class="tag-outra-categoria">
                            <span class="accent-color">{{ categoriaDoTipoAtual.nome }}</span>
                            <i class="pi pi-trash tag-outra-categoria-remover" matTooltip="Remover dessa categoria" (click)="removerTipoDeOutraCategoriaClick(tipo, $event)"></i>
                          </span>
                        }
                      </td>
                    </tr>
                  }
                </ng-template>

              </p-table>

            </div>
          </ng-template>

        </p-splitter>

      </div>


    </mat-card>

  </div>

</smrts-page>
